import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import Filter from "./Filter";
import JadwalList from "./ListJadwal";
import SedangProsesList from "./ListSedangProses";
import SelesaiList from "./ListSelesai";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import { setLayoutDashboardTitle } from "../../../../../store/ui-slice";
import { use } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import extractUrlParams from "../api/extract-url-params";
import useIsMobile from "../../../../../hooks/useIsMobile";


const title = "Pengecekan Kendaraan Keluar / Masuk ( MOBIL )";
const titleSmall = "Pengecekan Mobil";

const CekKeluarMasukArsipMain = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const listJadwalRef = useRef(null);
  const listSedangProsesRef = useRef(null);
  const listSelesaiRef = useRef(null);

  const [filterValue, setFilterValue] = useState({
    dari: new Date(),
    sampai: new Date(),
    data_kendaraan: undefined,
  });
  const [loadingAll, setLoadingAll] = useState({
    jadwal: false,
    sedangProses: false,
    selesai: false,
  });

  // useEffect section

  useEffect(() => {
    dispatch(
      setLayoutDashboardTitle({
        title: isMobile ? titleSmall : title,
      })
    );
    firstFetch();
  }, []);

  // other function section

  const firstFetch = async () => {
    const { page, take, filter, filterValue } = await extractUrlParams(
      location
    );
    if (filterValue) {
      setFilterValue(filterValue);
    }
  };

  //   handle ui section event

  const handleOnClickNew = () => {
    const urlParams = new URLSearchParams(location.search);
    const key = urlParams.get("key");
    let url = "/transaksi/cek-keluar-masuk/berangkat/new";
    if (key) {
      const encodedKey = encodeURIComponent(key);
      url += `?key=${encodedKey}`;
    }
    navigate(url);
  };

  const handleOnClickReload = () => {
    if (listJadwalRef.current) {
      listJadwalRef.current.reload();
    }
    if (listSedangProsesRef.current) {
      listSedangProsesRef.current.reload();
    }
    if (listSelesaiRef.current) {
      listSelesaiRef.current.reload();
    }
  };

  const handleJadwalLoadingChange = useCallback((isLoading) => {
    setLoadingAll((prev) => {
      if (prev.jadwal !== isLoading) {
        return { ...prev, jadwal: isLoading };
      }
      return prev;
    });
  }, []);

  const handleSedangProsesLoadingChange = useCallback((isLoading) => {
    setLoadingAll((prev) => {
      if (prev.sedangProses !== isLoading) {
        return { ...prev, sedangProses: isLoading };
      }
      return prev;
    });
  }, []);

  const handleSelesaiLoadingChange = useCallback((isLoading) => {
    setLoadingAll((prev) => {
      if (prev.selesai !== isLoading) {
        return { ...prev, selesai: isLoading };
      }
      return prev;
    });
  }, []);

  return (
    <div className={`col-start-start px-4 gap-4 w-100`}>
      <ConfirmDialog />

      <div></div>

      <Filter
        loading={
          loadingAll.jadwal || loadingAll.sedangProses || loadingAll.selesai
        }
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        onReload={handleOnClickReload}
        onNew={handleOnClickNew}
      />

      <JadwalList
        ref={listJadwalRef}
        filterValue={filterValue}
        onLoadingChange={handleJadwalLoadingChange}
      />

      <SedangProsesList
        ref={listSedangProsesRef}
        filterValue={filterValue}
        onLoadingChange={handleSedangProsesLoadingChange}
      />

      <SelesaiList
        ref={listSelesaiRef}
        filterValue={filterValue}
        onLoadingChange={handleSelesaiLoadingChange}
      />
    </div>
  );
};

export default CekKeluarMasukArsipMain;
